import React from 'react';
import { Home } from 'lucide-react';
import Header from '../components/Header';

const NotFoundPage: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Header />

            <main className="flex-grow flex flex-col items-center justify-center px-6 py-20 text-center relative z-20 overflow-hidden">
                {/* Decorative background elements */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl -z-10 animate-pulse"></div>

                <div className="max-w-md mx-auto">
                    <div className="mb-12 relative inline-block">
                        <div className="text-[120px] font-bold text-brand-gold/10 leading-none select-none tracking-tighter">404</div>
                    </div>

                    <h1 className="text-3xl font-bold text-brand-dark mb-4 font-serif">הדף לא נמצא</h1>
                    <p className="text-lg text-brand-dark/60 mb-10 leading-relaxed font-light">
                        מצטערים, אך נראה שהדף שחיפשתם אינו קיים או שהועבר לכתובת אחרת.
                    </p>

                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                        <a
                            href="https://karenavnam.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full sm:w-auto px-10 py-4 bg-brand-dark text-white font-bold rounded-2xl transition-all hover:bg-brand-dark/90 hover:shadow-lg transform hover:-translate-y-1 active:scale-95 flex items-center justify-center gap-2"
                        >
                            <Home className="w-5 h-5" />
                            חזרה לאתר הבית
                        </a>

                        <button
                            onClick={() => window.history.back()}
                            className="w-full sm:w-auto px-10 py-4 bg-white border-2 border-brand-gold/20 text-brand-dark font-bold rounded-2xl transition-all hover:border-brand-gold/40 hover:bg-brand-gold/5 transform hover:-translate-y-1 active:scale-95"
                        >
                            חזרה לדף הקודם
                        </button>
                    </div>
                </div>

                {/* Aesthetic quote */}
                <p className="absolute bottom-10 text-sm text-brand-dark/30 italic font-light">
                    "לפעמים צריך ללכת לאיבוד כדי למצוא את הדרך הנכונה"
                </p>
            </main>

            <footer className="py-8 text-center text-xs text-brand-dark/30 border-t border-brand-gold/10">
                &copy; 2026 קארן אבנם - ייעוץ ארגוני ופיתוח מנהיגות
            </footer>
        </div>
    );
};

export default NotFoundPage;
